import { mountWikiSidebar } from './mount_sidebar.js?vue3';
import { mountWikiApp, mountSidebarResizer } from './mount_content.js?vue3';

export const mountApplications = () => {
  mountWikiApp();
  mountSidebarResizer();
  mountWikiSidebar();
};
